<template>
    <div>
        <audio id="remote_audio"></audio>
        <audio id="dtmf_click" src="/sounds/dtmf.mp3"></audio>

        <div id="block-queue" v-if="calls_in_queue > 0" class="py-1 px-2"><span class="text">Звонков в очереди</span><span class="number text-lg ml-2">{{calls_in_queue}}</span></div>
        <!-- Панель телефонии: соединение · Входящие · Дайлер · настройки -->
        <div id="webphone_indicates_wrap" class="wp-bar" :class="'wp-bar--' + connection_state.code" v-if="user_sip_setting.use">
            <el-tooltip :content="connection_state.hint" placement="top" :open-delay="300" popper-class="webphone-tooltip">
                <span class="wp-status">
                    <span class="wp-status__dot"></span>
<!--                    <span class="wp-status__login">{{ user_sip_setting.login || '—' }}</span>-->
                </span>
            </el-tooltip>

            <span class="wp-sep"></span>

            <el-tooltip :content="user_sip_status ? 'Входящие звонки принимаются. Нажмите, чтобы отключить' : 'Входящие отключены. Нажмите, чтобы принимать'" placement="top" :open-delay="300" popper-class="webphone-tooltip">
                <button type="button" class="wp-chip" :class="{'is-on': user_sip_status}" :disabled="user_sip_settings_loading" @click="user_sip_status = !user_sip_status">
                    <i class="fas" :class="user_sip_status ? 'fa-phone' : 'fa-phone-slash'"></i><span class="wp-chip__label">Входящие</span>
                </button>
            </el-tooltip>

            <!-- Дайлер включается в одной вкладке: звонки автообзвона приходят только на её SIP -->
            <el-tooltip v-if="dialer_available" :content="dialer_tab_hint" placement="top" :open-delay="300" popper-class="webphone-tooltip">
                <button type="button" class="wp-chip" :class="{'is-on': dialer_tab_here, 'is-elsewhere': dialer_tab_elsewhere}" :disabled="dialer_tab_loading || !registered" @click="dialer_tab = !dialer_tab_here">
                    <i class="fas fa-headset"></i><span class="wp-chip__label">Дайлер</span><span v-if="dialer_tab_elsewhere" class="wp-chip__note">в другой вкладке</span>
                </button>
            </el-tooltip>

            <span class="wp-sep"></span>

            <button type="button" class="wp-icon" title="Настройки телефонии" @click="settingShowed = true"><i class="fas fa-cog"></i></button>
        </div>
        <el-dialog title="Настройки телефонии" :visible.sync="settingShowed" width="300px" :append-to-body="true">
            <div class="form-group row mb-1">
                <label for="setting_ringtone_volume" class="col-sm-12 col-form-label">Громкость рингтона для входящих</label>
                <div class="col-sm-2">
                    <button class="btn btn-primary btn-sm" @click="testRingtonePlay"><i class="fas fa-play"></i></button>
                </div>
                <div class="col-sm-10">
                    <input id="setting_ringtone_volume" type="range" class="custom-range" min="0" max="1" step="0.1" v-model="ringtone_volume">
                </div>
            </div>
        </el-dialog>
        <div id="block-call" ref="block_call" v-if="panel_visible">
            <!-- Постобработка после звонка дайлера: панель не исчезает, а меняет содержимое -->
            <div class="acw-panel incoming-call" v-if="acw_visible">
                <div class="info acw-info">
                    <div class="acw-head">
                        <span class="acw-title">Постобработка</span>
<!--                        <span class="acw-sub">после звонка дайлера</span>-->
                    </div>
                    <!-- Та же строка заявки, что и во время звонка -->
                    <div class="contact">
                        <a class="link-contact" @click="dialerOpenAcwRequest">Заявка №{{ dialer_acw_request_id }}</a>
                        <router-link target="_blank" :to="'/requests/' + dialer_acw_request_id"><i class="fas fa-external-link-alt px-1 text-white" style="font-size: 1rem;"></i></router-link>
                        <RequestStatusBadge v-if="acw_request" class="d-inline-block" :slug="acw_request.status"/>
                    </div>
                </div>
                <div class="acw-actions">
                    <button type="button" class="acw-btn acw-btn--primary" @click="dialerOpenAcwRequest">Открыть заявку</button>
                    <el-tooltip content="Завершить постобработку без сохранения заявки. Дайлер снова начнёт присылать звонки" placement="top" :open-delay="200" popper-class="webphone-tooltip">
                        <button type="button" class="acw-btn acw-btn--ghost" @click="dialerReady()">Готов к звонкам</button>
                    </el-tooltip>
                    <el-tooltip v-if="dialer_attempt_id" content="Пометить звонок + вернуть в дайлер если необходимо" placement="top" :open-delay="200" popper-class="webphone-tooltip">
                        <button type="button" class="acw-btn acw-btn--link" :disabled="dialer_machine_sending" @click="dialerMarkMachine()"><i class="fas fa-robot"></i> Это был автоответчик</button>
                    </el-tooltip>
                </div>
            </div>
            <!-- Панель звонка: клиент | источник и заявка | кнопки. Входящий: источник звонка, номер набора, найденная заявка;
                 исходящий: источник заявки, номер, с которого звоним, заявка. У звонка дайлера и когда показывать нечего
                 колонки нет — две колонки, как раньше -->
            <div class="call-panel" :class="{'call-panel--info': call_info.visible}" v-if="session" role="region" :aria-label="session.direction === 'incoming' ? 'Входящий звонок' : 'Исходящий звонок'">
                <div class="cp-caller">
                    <div class="cp-top">
                        <span class="cp-phone" :class="{'text-success': session.direction ==='incoming', 'text-danger': session.direction !=='incoming'}">{{phoneView(session_data.phone_number_normalize)}}</span>
                        <span class="cp-status" role="status">{{current_call_status}}</span>
                        <span id="stopwatch" v-if="call_active">{{current_call_stopwatch}}</span>
                    </div>
                    <div class="cp-name" v-if="session_request">
                        <a class="link-contact" @click="requestOpenDrawer">{{session_request_full_name}}</a>
                        <router-link target="_blank" :to="session_request_url"><i class="fas fa-external-link-alt px-1 text-white" style="font-size: 1rem;"></i></router-link>
                        <RequestStatusBadge class="d-inline-block" :slug="session_request.status"/>
                        <CreditScoreIcon class="ml-2" :score="session_request.credit_score"/>
                    </div>
                    <div class="cp-line" v-if="session_request">
                        <span class="cp-muted">Площадка: </span><span>{{session_request_platform ? session_request_platform.name : ''}}</span>
                    </div>
                    <div class="cp-line" v-if="session_request">
                        <span class="cp-muted">Оператор: </span><span>{{session_request.operator ? session_request.operator.name : 'Не назначен'}}</span>
                    </div>
                </div>

                <div class="cp-info" v-if="call_info.visible">
                    <div class="cp-source" :class="{'cp-source--accent': call_info.accent}">
                        <div class="cp-source__label">{{call_info.sourceLabel}}</div>
                        <div class="cp-source__name" :title="call_info.sourceName">{{call_info.sourceName}}</div>
                        <div class="cp-source__dst" v-if="call_info.dialedNumber"><span class="cp-muted">{{call_info.numberLabel}} </span>{{call_info.dialedNumber}}</div>
                    </div>
                    <!-- Найденная заявка: заявки нет (или нет доступа к ней) — блока нет, остаются подписи варианта -->
                    <div class="cp-found" v-if="call_info.request">
                        <div class="cp-request">
                            <button type="button" class="cp-link" :title="'Открыть заявку №' + call_info.request.id" @click="openAppealRequest(call_info.request.id)">{{call_info.request.title}}</button>
                            <span class="cp-muted">· {{call_info.request.date}}</span>
                        </div>
                        <div class="cp-line" v-if="call_info.request.sourceName">
                            <span class="cp-muted">{{call_info.request.sourceLabel}} </span>{{call_info.request.sourceName}}
                        </div>
                        <div class="cp-line" v-for="person in call_info.request.people" :key="person.label">
                            <span class="cp-muted">{{person.label}}: </span>{{person.name}}
                        </div>
                    </div>
                    <!-- Подписи варианта, как в ТЗ: «Другой источник», «Тот же источник · …», «Заявок не найдено», «Срок дубля … истёк» -->
                    <div v-for="(notice, i) in call_info.notices" :key="i" class="cp-notice" :class="'cp-notice--' + notice.tone">
                        <svg v-if="notice.tone === 'warning'" class="cp-warn" viewBox="0 0 20 20" aria-hidden="true"><path fill="currentColor" d="M9 2a1.2 1.2 0 0 1 2 0l8 15a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1z"/><path stroke="#29394b" stroke-width="2" d="M10 7v5"/><circle cx="10" cy="15" r="1" fill="#29394b"/></svg>{{notice.text}}
                    </div>
                </div>

                <div class="cp-actions" :class="{'cp-actions--single': session.direction !== 'incoming' || call_active}">
                    <div class="answer-btn-wrap d-inline-block" v-if="session.direction ==='incoming' && !call_active">
                        <button class="btn btn-lg btn-success btn-webphone-action animate" title="Ответить" aria-label="Ответить на звонок" @click="answer()"><PhoneCallIcon /></button>
                    </div>
                    <div class="reject-btn-wrap d-inline-block">
                        <button class="btn btn-lg btn-danger btn-webphone-action" :title="call_active ? 'Завершить звонок' : 'Отклонить'" :aria-label="call_active ? 'Завершить звонок' : 'Отклонить звонок'" @click="reject()"><PhoneOffIcon /></button>
                    </div>
                    <!-- Второстепенные действия под красной кнопкой: клавиатура и, на звонках дайлера, «Автоответчик» -->
                    <div class="call-side-actions" v-if="call_active">
                        <el-tooltip :content="keyboard_visible ? 'Скрыть клавиатуру' : 'Клавиатура для тонального набора'" placement="top" :open-delay="200" popper-class="webphone-tooltip">
                            <button type="button" class="call-sq" :class="{'is-active': keyboard_visible}" @click.prevent="keyboard_visible = !keyboard_visible">
                                <i class="fas fa-th"></i>
                            </button>
                        </el-tooltip>
                        <el-tooltip v-if="dialer_call" content="Автоответчик: пометить звонок + завершить звонок + вернуть в дайлер если необходимо" placement="top" :open-delay="200" popper-class="webphone-tooltip">
                            <button type="button" class="call-sq call-sq--am" :disabled="dialer_machine_sending" @click="dialerMarkMachine()">
                                <i class="fas fa-robot"></i><span class="call-sq__tag">АО</span>
                            </button>
                        </el-tooltip>
                    </div>
                </div>
                <Keyboard style="position: absolute;bottom: 0;right: -150px;" v-if="keyboard_visible" @press="sendDTMF" />
            </div>
        </div>
        <!-- Выбор исходящего номера: «Компактные строки», стоит там же, где панель звонка (внизу слева), звонок уходит с выбранного номера -->
        <OutgoingNumberPicker
            v-if="select_outgoing_phone_visible"
            :raised="!!session"
            :providers="outgoing_providers"
            :loading="select_outgoing_phone_loading"
            :error="select_outgoing_phone_error"
            :client-name="outgoing_client_name"
            :client-phone="outgoing_client_phone"
            @call="onPickerCall"
            @close="select_outgoing_phone_visible = false"
        />
        <!-- «Вы услышали человека?»: ответ обязателен, закрыть окно нельзя -->
        <CallOutcomeDialog :visible="show_question_heard_human" @answer="setAnswerHeardHuman" />
    </div>

</template>
<script>
// import WebPhoneObject from "../../plugins/webphone";
import {PhoneCallIcon,PhoneOffIcon} from "vue-feather-icons";
import RequestStatusBadge from "../requests/RequestStatusBadge";
import axios from "axios";
import PlatformHelper from "../../helpers/platform";
import CreditScoreIcon from "../requests/CreditScoreIcon";
import Keyboard from "./Keyboard.vue";
import OutgoingNumberPicker from "./OutgoingNumberPicker";
import CallOutcomeDialog from "./CallOutcomeDialog";
import outgoingNumbers from "./outgoingNumbers";
import appeals from "../../helpers/appeals";
const JsSIP = require('jssip');

export default {
    name: "WebPhone",
    components: {Keyboard, CreditScoreIcon, RequestStatusBadge, PhoneCallIcon,PhoneOffIcon, OutgoingNumberPicker, CallOutcomeDialog},
    data: () => ({
        UA: null,
        session: null,
        session_data: {
            phone_number: null,
            phone_number_normalize: null
        },
        // Входящий: что известно про обращение (helpers/appeals.js собирает из этого колонку обращения в панели).
        // Источник по номеру набора приходит сразу, запись звонка с решением — следом, при гонке с повторами
        incoming_source_phone: null,    // ответ source_phones/findByPhone по номеру из Diversion
        incoming_call: null,            // запись именно этого звонка из latestIncomingByPhone; null — нет или не наша
        session_request: null,
        session_request_loading: false,
        connected: false,
        registered: false,
        call_active: false,
        was_call_active: false,
        current_call_status: '',
        current_call_stopwatch: '00:00',

        stopwatch_starter: null,
        stopwatch_start: null,

        ringtone_element: null,

        call_request_id: null,
        last_call_request_id: null,
        // Идущий исходящий: что показывает его колонка в панели {request, from (номер, с которого звоним), source}. Отдельно от
        // окна выбора номера: открыв это окно для другого звонка, колонку идущего не подменить
        active_outgoing: null,
        // Окно выбора номера живёт своей жизнью: кому звоним и по какой заявке запоминаем при открытии, чтобы входящий
        // звонок или конец прошлого (они меняют и сбрасывают session_request / call_request_id) не подменили данные окна
        outgoing_call: null,        // {phone, request_id}
        outgoing_request: null,
        outgoing_source: null,      // основной источник заявки окна: {name}; null — ещё грузится
        outgoing_phones: [],
        outgoing_phones_loading: false,
        select_outgoing_phone_visible: false,
        select_outgoing_phone_loading: false,
        select_outgoing_phone_error: null,

        settingShowed: false,
        ringtone_volume: 1,

        user_sip_settings_loading: false,
        calls_in_queue: 0,

        show_question_heard_human: false,
        answer_question_heard_human: null,

        keyboard_visible: false,

        // Дайлер: ожидаемая нога (по Echo), текущая попытка и постобработка
        dialer_pending: null,       // {attempt_id, request_id, phone, until}
        dialer_call: false,         // текущий звонок пришёл от дайлера
        dialer_attempt_id: null,
        dialer_acw_request_id: null,
        dialer_acw_since: null,
        dialer_machine_sending: false,
        acw_request: null,          // заявка постобработки (для имени и статуса в панели)
        // Дайлерная вкладка: привязка ключуется по id вкладки (sessionStorage — переживает перезагрузку,
        // не виден другим вкладкам); SIP вкладки меняется при перезагрузке/переподключении, heartbeat его обновляет
        dialer_tab_id: null,          // id этой вкладки
        dialer_tab_bound_id: null,    // id вкладки, привязанной к дайлеру (с сервера)
        dialer_tab_login: null,       // SIP привязанной вкладки (с сервера)
        dialer_tab_loading: false,
        dialer_tab_timer: null,
        dialer_tab_heartbeat_sec: 20,
        dialer_tab_channel: null,     // BroadcastChannel: ответы на probe других вкладок
    }),
    mounted() {
        let self = this;
        this.$bus.$on('online_status:online_again',() => {
            self.validateSip()
                .then(res => {
                    if (!res.data) self.reconnectWithNewSip();
                })
        });
        if (this.user_sip_setting.call_center_id){
            Echo.private(`call_center.${this.user_sip_setting.call_center_id}`)
                .listen('.call_center.queue_updated', function (e) {
                    self.calls_in_queue = e.calls_in_queue;
                })
        }
        if (this.user_sip_setting.use) {
            // this.echoConnect(this.user_sip_setting.login);
            this.connect();
            this.$bus.$on('make-call', function (e) {
                self.outgoing_call = {phone: e.phone, request_id: e.request_id};
                self.outgoing_request = null;
                self.outgoing_source = null;
                self.fetchOutgoingSource(e.request_id);
                self.outgoing_phones = [];
                self.select_outgoing_phone_error = null;
                self.select_outgoing_phone_visible = true;
                self.select_outgoing_phone_loading = true;
                self.fetchOutgoingRequest(e.phone, e.request_id)
                    .then(function (request) {
                        // Заявка недоступна пользователю — выбирать номер не из чего
                        if (!request) {
                            self.select_outgoing_phone_visible = false;
                            return;
                        }
                        self.outgoing_request = request;
                        // Список номеров берём свежим: отключённые (карусель) сюда не попадают
                        return self.fetchOutgoingPhones();
                    })
                    .catch(function () {
                        self.select_outgoing_phone_error = 'Не удалось загрузить исходящие номера. Закройте окно и повторите.';
                    })
                    .then(function () {
                        self.select_outgoing_phone_loading = false;
                    });
            });
        }

        let ringtone_volume = parseFloat(localStorage.ringtone_volume);
        if (ringtone_volume) this.ringtone_volume = ringtone_volume;

        if (this.user_sip_setting.use) this.dialerSubscribe();
        window.addEventListener('beforeunload', this.dialerTabOnUnload);
    },
    beforeDestroy() {
        this.dialerTabStopHeartbeat();
        this.stopTrackingPanelHeight();
        window.removeEventListener('beforeunload', this.dialerTabOnUnload);
        if (this.dialer_tab_channel) { try { this.dialer_tab_channel.close(); } catch (e) {} this.dialer_tab_channel = null; }
    },
    watch: {
        dialer_acw_request_id: function (id) {
            if (!id) { this.acw_request = null; return; }
            if (this.acw_request && this.acw_request.id === id) return;
            // Заявка из только что завершённого звонка уже загружена — берём её, иначе подтягиваем
            if (this.session_request && this.session_request.id === id) { this.acw_request = this.session_request; return; }
            let self = this;
            axios.get('/api/requests/' + id).then(function (r) {
                if (r.data && r.data.id === id) self.acw_request = r.data;
            }).catch(() => {});
        },
        session: function (val) {
            if (!val) {
                this.call_request_id = null;
                this.session_request = null;
                this.active_outgoing = null;
                this.resetIncoming();
            }
        },
        // Панель показана/спрятана: окна звонков встают над ней, поэтому им нужна её настоящая высота
        panel_visible: function (visible) {
            this.$nextTick(() => this.trackPanelHeight(visible));
        },
        ringtone_volume: function (val) {
            localStorage.ringtone_volume = val
        },
    },
    computed: {
        session_request_full_name() {
            return this.requestFullName(this.session_request);
        },
        session_request_url() {
            return '/requests/' + this.session_request.id;
        },
        user_sip_setting() {
            return this.$store.getters['auth/sip_settings'];
        },
        // Строки окна выбора номера: номера площадки заявки по провайдерам, пустые провайдеры скрыты
        outgoing_providers() {
            return outgoingNumbers.groupProviders(this.outgoing_phones, this.outgoing_request ? this.outgoing_request.platform_id : null);
        },
        outgoing_client_name() {
            return this.outgoing_request ? this.requestFullName(this.outgoing_request) : '';
        },
        // Телефон клиента — по правам пользователя, как и в панели звонка; наши исходящие номера всегда показываются полностью
        outgoing_client_phone() {
            return this.outgoing_call ? this.phoneView('+7' + String(this.outgoing_call.phone).slice(-10)) : '';
        },
        acw_visible() {
            // Панель постобработки — продолжение звонка, поэтому только в дайлерной вкладке
            return !!this.dialer_acw_request_id && this.dialer_tab_here && !this.session && !this.select_outgoing_phone_visible;
        },
        panel_visible() {
            return !!(this.session || this.acw_visible);
        },
        // Колонка панели. Входящий: источник звонка и вариант окна (есть заявка — тот же/другой источник, заявок нет, заявка старше окна).
        // Исходящий: источник заявки, номер, с которого звоним, заявка. Звонок дайлера (мы звоним клиенту сами) — без колонки
        call_info() {
            const none = appeals.incomingView(null, null);
            if (!this.session) return none;
            if (this.session.direction === 'incoming') {
                return this.dialer_call ? none : appeals.incomingView(this.incoming_source_phone, this.incoming_call);
            }
            const out = this.active_outgoing;
            return out ? appeals.outgoingView(out.request, out.source) : none;
        },
        connection_state() {
            if (this.UA && this.registered) return {code: 'ok', hint: 'Телефония подключена'};
            if (this.UA && this.connected) return {code: 'warn', hint: 'Соединение есть, регистрация SIP ещё не прошла'};
            return {code: 'off', hint: 'Нет соединения с телефонией'};
        },
        dialer_available() {
            const user = this.$store.getters['auth/user'];
            return !!(user && user.dialer_enabled && this.user_sip_setting.use);
        },
        dialer_tab_here() {
            return !!this.dialer_tab_bound_id && this.dialer_tab_bound_id === this.dialer_tab_id;
        },
        dialer_tab_elsewhere() {
            return !!this.dialer_tab_bound_id && !this.dialer_tab_here;
        },
        dialer_tab_hint() {
            if (this.dialer_tab_here) return 'Дайлер: звонки автообзвона приходят в эту вкладку';
            if (this.dialer_tab_elsewhere) return 'Дайлер включён в другой вкладке. Включите здесь, чтобы перенести';
            return 'Дайлер выключен: включите, чтобы получать звонки автообзвона в этой вкладке';
        },
        dialer_tab: {
            get() {
                return this.dialer_tab_here;
            },
            set(val) {
                if (val) this.dialerTabBind();
                else this.dialerTabUnbind();
            }
        },
        user_sip_status: {
            get() {
                return this.user_sip_setting.status;
            },
            set(val) {
                let self = this;
                this.user_sip_settings_loading = true;
                this.$store.dispatch('auth/changeSipStatus', val)
                    .then(() => {
                        self.user_sip_settings_loading = false
                    })
            }
        },
        session_request_platform() {
            return this.session_request ? PlatformHelper.get(this.session_request.platform_id) : null;
        },
        // select_outgoing_phone_loading() {
        //     return this.session_request_loading || this.outgoing_phones_loading;
        // }
    },
    methods: {
        validateSip() {
            let self = this;
            return axios.get('/api/user/validateSip', {
                params: {
                    login: self.user_sip_setting.login,
                    call_server_id: self.user_sip_setting.call_server_id
                }
            })
        },
        phoneView(phone) {
            return this.$hasPermission('request.phone.show_full.without_challenge') ? phone : this.$hidePartPhone(phone);
        },
        requestOpenDrawer() {
            this.$bus.$emit('request:open-drawer', this.session_request.id);
        },
        connect() {
            JsSIP.debug.enable('JsSIP:*');

            let self = this;
            let user_settings = this.user_sip_setting;
            var socket = new JsSIP.WebSocketInterface(user_settings.ws_url);

            if (!user_settings.login) return;

            var configuration = {
                sockets: [socket],
                uri: 'sip:' + user_settings.login + '@' + user_settings.host,
                password: user_settings.password,
                session_timers: false,
            };
            this.UA = new JsSIP.UA(configuration);

            this.UA.on('connecting', function (e) {
                console.log('event_connecting');
                axios.post('/api/webphone_logging', {event_name: 'connecting', sip: user_settings.login, call_server_id: user_settings.call_server_id, data: JSON.stringify(e),});
            });
            this.UA.on('connected', function (e) {
                self.connected = true;
                console.log('connected');
                axios.post('/api/webphone_logging', {event_name: 'connected', sip: user_settings.login, call_server_id: user_settings.call_server_id, data: JSON.stringify(e),});
            });
            this.UA.on('disconnected', function (e) {
                self.connected = false;
                console.log('disconnected');
                axios.post('/api/webphone_logging', {event_name: 'disconnected', sip: user_settings.login, call_server_id: user_settings.call_server_id, data: JSON.stringify(e),});
            });
            this.UA.on('registered', function (e) {
                self.registered = true;
                console.log('event_registered');
                // Вкладка дайлерная, а SIP только что сменился (перезагрузка/переподключение) — сразу сообщаем новый логин
                if (self.dialer_tab_here) self.dialerTabHeartbeat();
                axios.post('/api/webphone_logging', {event_name: 'registered', sip: user_settings.login, call_server_id: user_settings.call_server_id, data: JSON.stringify(e),});
            });
            this.UA.on('unregistered', function (e) {
                self.registered = false;
                console.log('event_unregistered');
                axios.post('/api/webphone_logging', {event_name: 'unregistered', sip: user_settings.login, call_server_id: user_settings.call_server_id, data: JSON.stringify(e),});
            });
            this.UA.on('registrationFailed', function (e) {
                console.log('event_registrationFailed');
                axios.post('/api/webphone_logging', {event_name: 'registrationFailed', sip: user_settings.login, call_server_id: user_settings.call_server_id, data: JSON.stringify(e),});
                setTimeout(() => {
                    self.UA.register();
                }, 5000);
            });
            this.UA.on('registrationExpiring', function (e) {
                console.log('event_registrationExpiring');
                axios.post('/api/webphone_logging', {event_name: 'registrationExpiring', sip: user_settings.login, call_server_id: user_settings.call_server_id, data: JSON.stringify(e),});
                self.UA.register();
            });
            this.UA.on('newRTCSession', function (e) {
                self.setSession(e.session);
                console.log(e);
            });

            this.UA.start();
        },
        restart () {
            if (this.UA) {
                this.UA.stop();
            }
            if (this.UA) {
                this.UA.start();
            }
        },


        answer() {
            this.session.answer({
                mediaConstraints : { 'audio': true, 'video': false },
                pcConfig: {
                    hackStripTcp: true, // Важно для хрома, чтоб он не тупил при звонке
                    rtcpMuxPolicy: 'negotiate', // Важно для хрома, чтоб работал multiplexing. Эту штуку обязательно нужно включить на астере.
                    iceServers: [
                        // {'urls': ['stun:stun.l.google.com:19302']},
                    ],
                },
            });
        },
        /**
         * Звонок с номера, выбранного в окне. Заголовки (id и контекст номера) собираются из него одного:
         * воркер исходящих по ним выбирает номер, поэтому никакого «состояния выбора» между кликами не храним.
         */
        call(phone, request_id, selection) {
            this.answer_question_heard_human = null;
            try {
                const headers = outgoingNumbers.callHeaders(selection, request_id, this.user_sip_setting.login, this.$store.getters['auth/user'].id);
                // Панель звонка, журнал и вопрос «Вы услышали человека?» берут заявку отсюда: пока окно было открыто,
                // они могли сброситься (конец прошлого звонка) или смениться (входящий)
                this.call_request_id = request_id;
                this.last_call_request_id = request_id;
                this.session_request = this.outgoing_request;
                this.active_outgoing = {request: this.outgoing_request, from: selection.number, source: this.outgoing_source};
                this.UA.call('7' + phone.slice(-10), {
                    mediaConstraints: {'audio': true, 'video': false},
                    extraHeaders: headers,
                    pcConfig: {
                        hackStripTcp: true, // Важно для хрома, чтоб он не тупил при звонке
                        rtcpMuxPolicy: 'negotiate', // Важно для хрома, чтоб работал multiplexing. Эту штуку обязательно нужно включить на астере.
                        iceServers: [
                            // {'urls': ['stun:stun.l.google.com:19302']},
                        ],
                    },
                });
            } catch (e) {
                console.error(e);
                this.active_outgoing = null;
                this.select_outgoing_phone_error = 'Не удалось начать звонок. Проверьте соединение и повторите.';
                return;
            }
            this.select_outgoing_phone_visible = false;
        },
        onPickerCall(selection) {
            this.select_outgoing_phone_error = null;
            this.call(this.outgoing_call.phone, this.outgoing_call.request_id, selection);
        },
        reject() {
            this.session.terminate();
        },




        setSession(s) {
            let self = this;
            // Время INVITE по часам браузера: запасной вариант, если у ответа сервера нет заголовка Date (см. fetchOwnIncomingCall)
            const invite_at = Date.now();
            this.was_call_active = false;
            this.resetIncoming();
            this.session = s;


            this.session.on('peerconnection', function () {console.log('--------> peerconnection');});
            this.session.on('connecting', function () {console.log('--------> connecting');});
            this.session.on('sending', function () {console.log('--------> sending');});
            this.session.on('progress', function () {console.log('--------> progress');});
            this.session.on('accepted', function () {console.log('--------> accepted');});
            this.session.on('confirmed', function () {console.log('--------> confirmed');});
            this.session.on('ended', function () {console.log('--------> ended');});
            this.session.on('failed', function () {console.log('--------> failed');});

            this.session.on('progress', function () {
                if (self.session.direction === 'incoming' && !self.dialer_call) self.ringtoneStart();
                self.current_call_status = 'Ожидает ответа';
            });
            this.session.on('peerconnection', (e) => {
                const peerconnection = e.peerconnection;
                peerconnection.onaddstream = function(e) {
                    window.remote_audio.srcObject = e.stream;
                    window.remote_audio.play();
                };
                var remoteStream = new MediaStream();
                peerconnection.getReceivers().forEach(function(receiver) {
                    remoteStream.addTrack(receiver.track);
                });
            });
            this.session.on('connecting', function () {
                self.current_call_status = 'Соединяемся';
            });
            this.session.on('accepted', function () {
                self.current_call_status = 'Соединились';
                if (self.session && self.session.direction === 'incoming') self.ringtonePause();
            });
            this.session.on('confirmed', function() {
                self.startStopwatch();
                self.current_call_status = 'Идет разговор';
                self.call_active = true;
                self.was_call_active = true;
                console.log(self.session);
                // var localStream = self.session.connection.getLocalStreams()[0];
                // var dtmfSender = self.session.connection.createDTMFSender(localStream.getAudioTracks()[0]);
                // self.session.sendDTMF = function(tone) {
                //     dtmfSender.insertDTMF(tone);
                // };
            });
            this.session.on('ended', function (e) {
                self.showPolling();
                self.stopShowingCall();
                self.current_call_status = 'Завершен';
                let initiator_of_ending;
                switch (e.originator) {
                    case "local": initiator_of_ending = 'operator'; break;
                    case "remote": initiator_of_ending = 'client'; break;
                    default: initiator_of_ending = null;
                }
                self.setCallInitiatorOfEnding(initiator_of_ending);
                if (e.originator === 'local')
                    console.log(e);
            });
            this.session.on('failed', function (e) {
                self.showPolling();
                self.stopShowingCall();
                self.current_call_status = 'Оборван';
                console.log(e);
            });


            if (this.session.direction === 'incoming') {
                // incomingCallAudio.play();
            } else {
                console.log('con', this.session.connection);
                this.session.connection.addEventListener('addstream', function(e) {
                    window.remote_audio.srcObject = e.stream;
                    window.remote_audio.play();
                });
            }

            if (
                this.session._request
                && this.session._request.headers
                && this.session._request.headers.Diversion
                && this.session._request.headers.Diversion[0]
                && this.session._request.headers.Diversion[0].raw
            ) {
                let header_incoming_phone = this.session._request.headers.Diversion[0].raw;
                let regex_incoming_phone = RegExp(/\<[a-z0-9]+:(\d+)@/gm).exec(header_incoming_phone);
                if (regex_incoming_phone && regex_incoming_phone[1]){
                    this.fetchIncomingPhoneInfo(regex_incoming_phone[1]);
                }
            }
            this.session_data.phone_number = this.session.remote_identity.uri.user;
            this.session_data.phone_number_normalize = '+7' + this.session_data.phone_number.slice(-10);

            // Если входящий, то нужно искать последний созданный звонок и подтягивать заявку
            // Иначе, это исходящий и заявка уже есть и ничего не нужно искать
            if (this.session.direction === 'incoming' && this.isDialerCall()) {
                // Нога дайлера: отвечаем сами, короткий сигнал оператору, открываем карточку
                this.dialer_call = true;
                const pending = this.dialer_pending || {};
                this.dialer_attempt_id = pending.attempt_id || this.dialerHeader('X-Crm-Attempt-Id');
                const request_id = pending.request_id || this.dialerHeader('X-Crm-Request-Id');
                this.dialer_pending = null;
                this.answer();
                this.zipTone();
                this.fetchRequest(this.session_data.phone_number_normalize, request_id)
                    .then(function () {
                        if (self.session_request) self.requestOpenDrawer();
                    });
            } else if (this.session.direction === 'incoming') {
                this.loadIncoming(s, this.session_data.phone_number_normalize, invite_at);
            }
        },
        resetIncoming() {
            this.incoming_source_phone = null;
            this.incoming_call = null;
        },
        /**
         * Входящий: колонка обращения и заявка звонка. Источник по номеру набора грузит fetchIncomingPhoneInfo (из setSession).
         * Здесь: запись именно этого звонка (она несёт решение — вариант окна и заявку), потом заявка по ней.
         * Записи сразу нет — оператору не ждём повторов: заявка по телефону показывается, как раньше, а запись ищется в фоне
         * и, когда найдётся, окно уточняется. Не нашлась вовсе — остаётся «прежнее окно»: заявка по телефону и источник.
         */
        loadIncoming(session, phone, invite_at) {
            const self = this;
            let fetched_by_phone = false;
            return this.fetchOwnIncomingCall(session, phone, invite_at, function () {
                if (self.session !== session) return;
                fetched_by_phone = true;
                self.fetchRequest(phone);
            })
                .then(function (call) {
                    // Пока искали, звонок закончился или пришёл другой: окно уже не про него
                    if (self.session !== session) return;
                    self.incoming_call = call;
                    if (call) return self.fetchRequest(phone, call.request_id);
                    if (!fetched_by_phone) return self.fetchRequest(phone);
                });
        },
        /**
         * Запись звонка, который звонит сейчас. Она появляется почти одновременно с INVITE оператору, поэтому первый ответ
         * бывает пустым или с прошлым звонком клиента: повторяем по паузам из helpers/appeals, пока не придёт наш звонок
         * (isOwnCall сверяет called_at со временем сервера из заголовка Date, а без него — со временем INVITE).
         * on_miss вызывается один раз, когда первый ответ оказался пустым или чужим.
         * Ошибка сети или кончились повторы — null, окно остаётся прежним. Resolves: запись звонка или null.
         */
        fetchOwnIncomingCall(session, phone, invite_at, on_miss) {
            const self = this;
            const attempt = function (n) {
                return axios.get('/api/calls/latestIncomingByPhone/' + phone).then(function (response) {
                    if (self.session !== session) return null;
                    const call = response.data || null;
                    if (appeals.isOwnCall(call, appeals.referenceTime(response, invite_at))) return call;
                    if (n === 0 && on_miss) on_miss();
                    if (n >= appeals.RETRY_DELAYS_MS.length) return null;
                    return new Promise(function (resolve) { setTimeout(resolve, appeals.RETRY_DELAYS_MS[n]); })
                        .then(function () { return attempt(n + 1); });
                });
            };
            return attempt(0).catch(function () { return null; });
        },
        openAppealRequest(request_id) {
            this.$bus.$emit('request:open-drawer', request_id);
        },
        /**
         * Окна звонков (CallDialog, bottom-left) встают над панелью звонка на её высоту (--webphone-panel-height).
         * У панели с обращением строк больше, чем у обычной, и высота меняется, пока данные подгружаются, —
         * поэтому передаём окнам настоящую высоту, а не константу.
         */
        trackPanelHeight(visible) {
            this.stopTrackingPanelHeight();
            const panel = this.$refs.block_call;
            if (!visible || !panel) return;
            const apply = () => this.$el.style.setProperty('--webphone-panel-height', panel.offsetHeight + 'px');
            apply();
            if (typeof ResizeObserver !== 'undefined') {
                this.panel_observer = new ResizeObserver(apply);
                this.panel_observer.observe(panel);
            }
        },
        stopTrackingPanelHeight() {
            if (this.panel_observer) {
                this.panel_observer.disconnect();
                this.panel_observer = null;
            }
            // Панели нет — окна снова берут обычную высоту из :root
            if (this.$el && this.$el.style) this.$el.style.removeProperty('--webphone-panel-height');
        },
        fetchRequest(phone, request_id) {
            let self = this;
            // Запросы заявки могут идти вперемешку (по телефону, потом по звонку): применяем ответ только последнего
            const fetch_id = this.request_fetch_id = (this.request_fetch_id || 0) + 1;
            self.session_request_loading = true;
            return axios.get('/api/requests/findByPhone/' + phone + (request_id ? "?request_id=" + request_id : ""))
                .then(function (response) {
                    if (fetch_id !== self.request_fetch_id) return;
                    if (self.session && self.session.direction === 'incoming' && !response.data) { // Не нашли заявку в КЦ юзера
                        self.stopShowingCall();
                        self.reconnectWithNewSip();
                        console.log('Не нашли заявку в КЦ юзера');
                    }

                    self.session_request = response.data;
                    self.session_request_loading = false;
                })
                .catch(() => {
                    self.session_request_loading = false
                })
        },
        /**
         * Заявка для окна выбора номера. Свой запрос, а не fetchRequest: тот пишет в session_request,
         * то есть меняет панель идущего звонка, а на входящем без заявки ещё и сбрасывает звонок.
         * null — заявки нет или она недоступна пользователю.
         */
        fetchOutgoingRequest(phone, request_id) {
            return axios.get('/api/requests/findByPhone/' + phone + (request_id ? "?request_id=" + request_id : ""))
                .then(function (response) {
                    return response.data || null;
                });
        },
        /**
         * Основной источник заявки для колонки панели исходящего: requests/findByPhone его не отдаёт, берём из карточки заявки.
         * Грузим при открытии окна выбора номера, пока оператор выбирает номер, — к началу звонка источник уже есть.
         * Не получилось — источник «не определён», звонку это не мешает.
         */
        fetchOutgoingSource(request_id) {
            const self = this;
            const apply = function (name) {
                const source = {name: name};
                // Окно выбора номера уже открыли для другой заявки — этот ответ ему не нужен
                if (self.outgoing_call && String(self.outgoing_call.request_id) === String(request_id)) self.outgoing_source = source;
                // Звонок уже пошёл, а источник приехал позже — дописываем в идущий
                const active = self.active_outgoing;
                if (active && !active.source && String(active.request.id) === String(request_id)) active.source = source;
            };
            if (!request_id) return Promise.resolve(apply(null));
            return axios.get('/api/requests/' + request_id)
                .then(function (response) { apply(response.data && response.data.source ? response.data.source.name : null); })
                .catch(function () { apply(null); });
        },
        requestFullName(request) {
            let full_name = [request.last_name, request.first_name, request.middle_name].join(' ').trim();
            if (!full_name.length) full_name = 'Заявка №' + request.id;
            if (full_name.length > 35) full_name = full_name.slice(0, 31) + '...';
            return full_name;
        },
        /** Номер набора из Diversion → источник и салон, на которые звонят: известны сразу, до появления записи звонка */
        fetchIncomingPhoneInfo(phone) {
            let self = this;
            const session = this.session;
            return axios.get('/api/source_phones/findByPhone/' + phone)
                .then(function (response) {
                    // Звонок мог закончиться, пока шёл запрос: его данные не должны попасть в окно следующего
                    if (self.session === session) self.incoming_source_phone = response.data || null;
                })
                .catch(() => {})
        },

        ringtoneStart() {
            try {this.getRingtoneElement().play().catch(error => {});} catch (e) {}
        },
        ringtonePause() {
            try {this.getRingtoneElement().pause();} catch (e) {}
        },
        getRingtoneElement() {
            if (this.ringtone_element === null) {
                let element = document.createElement('audio');
                element.id = "audioPlayer";
                element.src = "/sounds/ringtone.wav";
                element.loop = true;
                document.body.appendChild(element);
                this.ringtone_element = element;
            }
            this.ringtone_element.volume = this.ringtone_volume;
            return this.ringtone_element;
        },
        startStopwatch () {
            this.stopwatch_start = new Date();
            this.stopwatch_starter = setInterval(this.runningStopwatch, 500);
        },
        stopStopwatch () {
            clearInterval(this.stopwatch_starter);
            this.stopwatch_start = null;
            this.current_call_stopwatch = '00:00';
        },
        runningStopwatch () {
            let currentTime = new Date();
            let timeElapsed = new Date(currentTime - this.stopwatch_start);
            let min = timeElapsed.getUTCMinutes();
            let sec = timeElapsed.getUTCSeconds();
            this.current_call_stopwatch = this.zeroPrefix(min, 2) + ":" + this.zeroPrefix(sec, 2)
        },
        zeroPrefix(num, digit) {
            let zero = '';
            for(let i = 0; i < digit; i++) {
                zero += '0';
            }
            return (zero + num).slice(-digit);
        },
        stopShowingCall() {
            let self = this;
            if (self.session && self.session.direction === 'incoming') self.ringtonePause();
            self.dialer_call = false;
            self.session = null;
            self.call_active = false;
            self.stopStopwatch();
        },


        fetchOutgoingPhones() {
            let self = this;
            this.outgoing_phones_loading = true;
            return axios.get('/api/call_centres/my/outgoing_phones')
                .then(function (response) {
                    self.outgoing_phones = response.data;
                    self.outgoing_phones_loading = false;
                })
        },

        testRingtonePlay() {
            let self = this;
            this.ringtoneStart();
            setTimeout(function () {
                self.ringtonePause();
            }, 3000)
        },

        echoConnect(sip_login) {
            let self = this;
            Echo.private(`user.${this.$store.getters['auth/user'].id}.sip.${sip_login}`)
                .listen('.user.busy_sip', function (e) {
                    self.$store.dispatch('auth/clearUserSip');
                    self.$store.dispatch('auth/fetchUser')
                        .then(() => {
                            if (self.UA) {
                                self.UA.stop();
                                let s = setInterval(() => {
                                    if (self.connected === false) {
                                        clearInterval(s);
                                        self.echoDisconnect(e.sip_login);

                                        self.connect();
                                        self.echoConnect(self.user_sip_setting.login);
                                    }
                                }, 1000);
                            }
                        })
                })
        },
        echoDisconnect(sip_login) {
            Echo.leave(`user.${this.$store.getters['auth/user'].id}.sip.${sip_login}`);
        },
        setCallInitiatorOfEnding(initiator) {
            axios.put('/api/calls/setInitiatorOfEnding', {
                request_id: this.session_request ? this.session_request.id : this.call_request_id,
                user_id: this.$store.getters['auth/user'].id,
                initiator: initiator,
            })
        },
        setAnswerHeardHuman(answer) {
            this.answer_question_heard_human = answer;
            this.show_question_heard_human = false;

            axios.put('/api/calls/setAnswerHeardHuman', {
                request_id: this.last_call_request_id,
                user_id: this.$store.getters['auth/user'].id,
                answer: answer,
            })
        },
        reconnectWithNewSip() {
            let self = this;
            self.$store.dispatch('auth/clearUserSip');
            self.$store.dispatch('auth/fetchUser')
                .then(() => {
                    if (self.UA) {
                        self.UA.stop();
                        let s = setInterval(() => {
                            if (self.connected === false) {
                                clearInterval(s);
                                self.connect();
                            }
                        }, 500);
                    }
                })
        },
        showPolling() {
            if (this.session.direction === 'outgoing' && this.last_call_request_id && this.was_call_active) this.show_question_heard_human = true;
        },
        sendDTMF(val) {
            try {document.getElementById('dtmf_click').play().catch(error => {});} catch (e) {}
            this.session.sendDTMF(val)
        },

        // ---------------- Дайлер ----------------
        dialerSubscribe() {
            let self = this;
            const user_id = this.$store.getters['auth/user'].id;
            Echo.private(`user.${user_id}`)
                .listen('.dialer.ringing', function (e) {
                    self.dialer_pending = Object.assign({}, e, {until: Date.now() + 15000});
                })
                .listen('.dialer.connected', function (e) {
                    self.dialer_attempt_id = e.attempt_id;
                })
                .listen('.dialer.acw', function (e) {
                    self.dialer_acw_request_id = e.cleared ? null : e.request_id;
                    self.dialer_acw_since = e.cleared ? null : new Date();
                })
                .listen('.dialer.tab', function (e) {
                    // Тумблер включили в другой вкладке (или сняли): здесь он гаснет, heartbeat останавливается
                    self.dialerTabApply(e.tab_id, e.sip_login);
                })
                .listen('.user.sip_status', function (e) {
                    // Приём входящих переключили в другой вкладке — тумблер здесь повторяет
                    self.$store.commit('auth/USER_CHANGE_SIP_STATUS', !!e.sip_status);
                });
            axios.get('/api/dialer/acw').then(function (r) {
                self.dialer_acw_request_id = r.data.request_id;
                self.dialer_acw_since = r.data.since ? new Date(r.data.since) : null;
            }).catch(() => {});
            if (this.dialer_available) {
                this.dialerTabResolveId().then(function (id) {
                    self.dialer_tab_id = id;
                    self.dialerTabListenProbes();
                    return axios.get('/api/dialer/tab');
                }).then(function (r) {
                    if (r.data.heartbeat_sec) self.dialer_tab_heartbeat_sec = r.data.heartbeat_sec;
                    self.dialerTabApply(r.data.tab_id, r.data.sip_login);
                    // Перезагрузка дайлерной вкладки: beforeunload уже снял привязку beacon'ом, но метка в sessionStorage
                    // осталась (у закрытой вкладки она умирает вместе с ней) — восстанавливаем привязку сами
                    let wasBound = false;
                    try { wasBound = sessionStorage.getItem('dialer_tab_rebind') === '1'; sessionStorage.removeItem('dialer_tab_rebind'); } catch (e) {}
                    if (wasBound && !r.data.tab_id) { self.dialerTabBind(); return; }
                    // Привязка пережила перезагрузку (beacon не дошёл), а SIP новый — heartbeat обновит логин
                    if (self.dialer_tab_here && self.registered) self.dialerTabHeartbeat();
                }).catch(() => {});
            }
        },
        /**
         * Id вкладки из sessionStorage. Chrome копирует sessionStorage при дублировании вкладки,
         * поэтому спрашиваем через BroadcastChannel, не занят ли id живой вкладкой: оригинал ответит,
         * и копия возьмёт новый id. При обычной перезагрузке отвечать некому — id сохраняется.
         */
        dialerTabResolveId() {
            const self = this;
            return new Promise(function (resolve) {
                let id = null;
                try { id = sessionStorage.getItem('dialer_tab_id'); } catch (e) {}
                if (!id) return resolve(self.dialerTabStoreId(self.dialerTabNewId()));
                if (typeof BroadcastChannel === 'undefined') return resolve(id);
                let done = false;
                const ch = new BroadcastChannel('one-crm-dialer-tab');
                const finish = function (v) { if (done) return; done = true; ch.close(); resolve(v); };
                ch.onmessage = function (e) {
                    if (e.data && e.data.type === 'taken' && e.data.id === id) finish(self.dialerTabStoreId(self.dialerTabNewId()));
                };
                ch.postMessage({type: 'probe', id: id});
                setTimeout(function () { finish(id); }, 250);
            });
        },
        dialerTabNewId() {
            return 't' + Date.now().toString(36) + Math.random().toString(36).slice(2, 10);
        },
        dialerTabStoreId(id) {
            try { sessionStorage.setItem('dialer_tab_id', id); } catch (e) {}
            return id;
        },
        /** Отвечаем новым вкладкам, что наш id занят (защита от дубликата вкладки) */
        dialerTabListenProbes() {
            if (typeof BroadcastChannel === 'undefined' || this.dialer_tab_channel) return;
            const self = this;
            this.dialer_tab_channel = new BroadcastChannel('one-crm-dialer-tab');
            this.dialer_tab_channel.onmessage = function (e) {
                if (e.data && e.data.type === 'probe' && e.data.id === self.dialer_tab_id) {
                    self.dialer_tab_channel.postMessage({type: 'taken', id: self.dialer_tab_id});
                }
            };
        },
        dialerTabApply(tab_id, sip_login) {
            this.dialer_tab_bound_id = tab_id || null;
            this.dialer_tab_login = sip_login || null;
            if (this.dialer_tab_here) this.dialerTabStartHeartbeat();
            else this.dialerTabStopHeartbeat();
        },
        dialerTabBind() {
            let self = this;
            const login = this.user_sip_setting.login;
            if (!login || this.dialer_tab_loading) return;
            this.dialer_tab_loading = true;
            axios.put('/api/dialer/tab', {tab_id: this.dialer_tab_id, sip_login: login})
                .then(function (r) { self.dialerTabApply(r.data.tab_id, r.data.sip_login); })
                .catch(function () { self.$message.error({message: 'Не удалось включить дайлер в этой вкладке', duration: 2500}); })
                .then(function () { self.dialer_tab_loading = false; });
        },
        dialerTabUnbind() {
            let self = this;
            this.dialer_tab_loading = true;
            axios.delete('/api/dialer/tab', {data: {tab_id: this.dialer_tab_id}})
                .then(function () { self.dialerTabApply(null, null); })
                .catch(() => {})
                .then(function () { self.dialer_tab_loading = false; });
        },
        dialerTabHeartbeat() {
            let self = this;
            const login = this.user_sip_setting.login;
            if (!this.dialer_tab_here || !login) return;
            return axios.post('/api/dialer/tab/heartbeat', {tab_id: this.dialer_tab_id, sip_login: login})
                .then(function (r) {
                    if (!r.data) return;
                    // Привязка ушла в другую вкладку между событиями — гасим тумблер здесь
                    if (r.data.bound === false) self.dialerTabApply(r.data.tab_id, r.data.sip_login);
                    else self.dialer_tab_login = r.data.sip_login || login;
                })
                .catch(() => {});
        },
        dialerTabOnUnload() {
            // Закрывается дайлерная вкладка: снимаем привязку сразу, не дожидаясь протухания heartbeat.
            // sendBeacon не ставит заголовков — токен идёт в теле (jwt-auth читает его из input)
            if (!this.dialer_tab_here || !navigator.sendBeacon) return;
            try {
                // Метка «эта вкладка была дайлерной»: переживёт перезагрузку, но не закрытие вкладки
                sessionStorage.setItem('dialer_tab_rebind', '1');
                const body = new URLSearchParams({token: this.$store.getters['auth/token'] || '', tab_id: this.dialer_tab_id});
                navigator.sendBeacon('/api/dialer/tab/close', body);
            } catch (e) {}
        },
        dialerTabStartHeartbeat() {
            let self = this;
            this.dialerTabStopHeartbeat();
            this.dialer_tab_timer = setInterval(function () {
                if (!self.dialer_tab_here) { self.dialerTabStopHeartbeat(); return; }
                self.dialerTabHeartbeat();
            }, this.dialer_tab_heartbeat_sec * 1000);
        },
        dialerTabStopHeartbeat() {
            if (this.dialer_tab_timer) {
                clearInterval(this.dialer_tab_timer);
                this.dialer_tab_timer = null;
            }
        },
        dialerHeader(name) {
            try {
                const v = this.session._request.getHeader(name);
                return v ? v : null;
            } catch (e) {
                return null;
            }
        },
        isDialerCall() {
            // Нога дайлера принимается только во вкладке, где включён тумблер «Дайлер»
            if (!this.dialer_tab_here) return false;
            if (this.dialerHeader('X-Dialer-Auto-Answer')) return true;
            const p = this.dialer_pending;
            if (!p || p.until < Date.now()) return false;
            // номер в событии и в INVITE — один и тот же клиент
            return !p.phone || p.phone.slice(-10) === this.session_data.phone_number_normalize.slice(-10);
        },
        zipTone() {
            try {document.getElementById('dtmf_click').play().catch(error => {});} catch (e) {}
        },
        dialerMarkMachine() {
            let self = this;
            if (!this.dialer_attempt_id || this.dialer_machine_sending) return;
            this.dialer_machine_sending = true;
            axios.put('/api/dialer/attempts/' + this.dialer_attempt_id + '/mark-machine')
                .then(function () {
                    self.$message.success({message: 'Отмечено как автоответчик', duration: 1500});
                    if (self.session) self.reject();
                })
                .catch(function () { self.$message.error({message: 'Не удалось отметить', duration: 2000}); })
                .then(function () { self.dialer_machine_sending = false; });
        },
        dialerReady() {
            let self = this;
            axios.delete('/api/dialer/acw').then(function () {
                self.dialer_acw_request_id = null;
                self.dialer_acw_since = null;
            });
        },
        dialerOpenAcwRequest() {
            if (this.dialer_acw_request_id) this.$bus.$emit('request:open-drawer', this.dialer_acw_request_id);
        },
    }
}
</script>

<style lang="scss" scoped>
// Панель телефонии: одна пилюля внизу справа
$wp-accent: #47BAC1;
$wp-muted: #6c757d;
$wp-line: #e6e9ec;
// Слои: карточка заявки (el-drawer) ~2000 → панель настроек / очередь / ACW 2990 → панель звонка 3000 → подсказки 3100
#webphone_indicates_wrap {
    position: fixed;
    bottom: 10px;
    right: 10px;
    z-index: 2990;
    display: flex;
    align-items: center;
    gap: 6px;
    height: 38px;
    padding: 0 6px 0 12px;
    background: #fff;
    border: 1px solid $wp-line;
    border-radius: 999px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, .10);
    font-size: 12px;
    line-height: 1;
    user-select: none;
}
.wp-status {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    color: $wp-muted;
    cursor: default;
    &__dot {
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: #dc3545;
        box-shadow: 0 0 0 3px rgba(220, 53, 69, .15);
        transition: background .2s, box-shadow .2s;
    }
    &__login {
        font-variant-numeric: tabular-nums;
        letter-spacing: .02em;
    }
}
.wp-bar--ok .wp-status__dot { background: #4CAF50; box-shadow: 0 0 0 3px rgba(76, 175, 80, .18); }
.wp-bar--warn .wp-status__dot { background: #f0ad4e; box-shadow: 0 0 0 3px rgba(240, 173, 78, .2); }
.wp-sep {
    width: 1px;
    height: 20px;
    background: $wp-line;
    margin: 0 2px;
}
.wp-chip {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    height: 28px;
    padding: 0 11px;
    border: 1px solid $wp-line;
    border-radius: 999px;
    background: transparent;
    color: $wp-muted;
    font: inherit;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    transition: background .15s, color .15s, border-color .15s;
    outline: none;
    i { font-size: 12px; width: 13px; text-align: center; }
    &:hover { background: #f3f5f7; color: #343a40; }
    &:focus-visible { box-shadow: 0 0 0 3px rgba(71, 186, 193, .25); }
    &:disabled { opacity: .45; cursor: default; }
    &.is-on {
        background: $wp-accent;
        border-color: $wp-accent;
        color: #fff;
        &:hover { background: darken($wp-accent, 6%); }
    }
    &.is-elsewhere {
        border-style: dashed;
        border-color: #f0ad4e;
        color: #9a6b12;
        &:hover { background: #fff8ec; }
    }
    &__note {
        font-weight: 400;
        opacity: .8;
    }
}
.wp-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    border: 0;
    border-radius: 50%;
    background: transparent;
    color: #adb5bd;
    cursor: pointer;
    outline: none;
    transition: background .15s, color .15s;
    &:hover { background: #f3f5f7; color: #495057; }
}
#block-queue {
    width: 200px;
    border-radius: 5px;
    position: fixed;
    bottom: 87px;
    right: 10px;
    z-index: 2991;
    background-color: #354052;
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;

    transition:.3s;
    -webkit-animation:queue linear 1s infinite;
    animation:queue linear 1s infinite;
    .text {
        font-size: 1rem;
    }
    .number {
        font-size: 1.2rem;
    }
}
#block-queue .number {

    //padding: 5px;
    //border-radius: 50%;
    //color: white;
    font-weight: bold;
}
$panel-min-height: 110px;
$cp-muted: #afc0d5;
$cp-divider: rgba(107, 122, 140, .6);
// Панель звонка: высота по содержимому, не ниже обычной (у окна с обращением строк больше).
// Окнам звонков (CallDialog, bottom-left) её настоящую высоту передаёт trackPanelHeight() через --webphone-panel-height.
// Рамка и фон — как у окон звонков: тёмный градиент, прижата к краям экрана, скруглён только свободный угол.
#block-call {
    box-sizing: border-box;
    width: var(--webphone-panel-width, 700px);
    max-width: 100%;
    min-height: $panel-min-height;
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 3000;
    color: #f1f4f8;
    background: linear-gradient(110deg, #2e3b4c, #253649);
    border: 1px solid #435266;
    border-width: 1px 1px 0 0;
    border-radius: 0 5px 0 0;
    box-shadow: 0 0 28px rgba(16, 25, 35, .35);

    // Строка заявки в панели постобработки дайлера (acw-panel)
    .acw-info .contact {
        color: white;
        font-size: 1.1rem;
        .link-contact {
            color: white;
        }
    }
}

// ---- Панель звонка: клиент | источник и заявка | кнопки. Внешний вид — по прототипу, вёрстка под ширину панели ----
.call-panel {
    position: relative;
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    align-items: center;
    gap: 14px;
    min-height: $panel-min-height - 1px; // за вычетом верхней рамки панели
    padding: 12px 16px 12px 20px;
    font-size: 15px;
    line-height: 1.35;
    // С колонкой источника (входящий и исходящий) клиенту хватает места под номер и имя, остальное — источнику и заявке
    &--info {
        grid-template-columns: minmax(180px, .72fr) minmax(0, 1.28fr) auto;
    }
}
.cp-muted { color: $cp-muted; }
.cp-caller {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-self: stretch;
    gap: 2px;
    min-width: 0;
    overflow-wrap: anywhere;
}
.call-panel--info .cp-caller {
    padding-right: 14px;
    border-right: 1px solid $cp-divider;
}
.cp-top {
    display: flex;
    flex-wrap: wrap;
    align-items: baseline;
    column-gap: 10px;
}
.cp-phone {
    font-size: 20px;
    line-height: 1.2;
}
.cp-status {
    color: $cp-muted;
    font-size: 13px;
}
#stopwatch {
    color: #fff;
    font-size: 17px;
    font-variant-numeric: tabular-nums;
    letter-spacing: .5px;
}
.cp-name {
    font-size: 17px;
    .link-contact {
        color: #fff;
        cursor: pointer;
    }
}
.cp-line {
    font-size: 14px;
}
.cp-info {
    min-width: 0;
    font-size: 13px;
    overflow-wrap: anywhere;

    .cp-line { font-size: 13px; }
}
// Источник текущего звонка; при «другой источник» слева жёлтая планка
.cp-source {
    position: relative;
    margin-bottom: 8px;
    padding-bottom: 8px;
    border-bottom: 1px solid $cp-divider;

    &--accent::before {
        content: '';
        position: absolute;
        top: 0;
        left: -11px;
        width: 4px;
        height: 36px;
        background: #ffd733;
        border-radius: 3px;
    }
    // Под источником больше ничего нет (окно как раньше): разделитель не нужен
    &:last-child {
        margin-bottom: 0;
        padding-bottom: 0;
        border-bottom: 0;
    }
    &__label {
        color: $cp-muted;
        font-size: 12px;
    }
    // Длинный источник — не больше двух строк, целиком в подсказке
    &__name {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        margin: 1px 0 3px;
        overflow: hidden;
        font-size: 16px;
        line-height: 1.3;
    }
}
.cp-found {
    margin: 3px 0;
}
.cp-request {
    display: flex;
    flex-wrap: wrap;
    align-items: baseline;
    gap: 0 7px;
}
.cp-link {
    padding: 0;
    color: #63c7fa;
    font: inherit;
    font-size: 13px;
    text-align: left;
    text-decoration: underline;
    text-underline-offset: 3px;
    background: none;
    border: 0;
    cursor: pointer;
    transition: color .15s;

    &:hover { color: #b4e8ff; }
    &:active { color: #fff; }
    &:focus-visible {
        border-radius: 2px;
        outline: 2px solid #79c5ff;
        outline-offset: 3px;
    }
}
.cp-notice {
    margin-top: 3px;

    &--ok { color: #6bd766; }
    &--warning { color: #ffdb37; }
    &--muted { color: $cp-muted; }
}
.cp-warn {
    width: 17px;
    height: 17px;
    margin-right: 5px;
    vertical-align: -3px;
}
// Кнопки: ответить и сбросить в ряд, под ними — клавиатура и «Автоответчик». Две колонки всегда,
// чтобы панель не прыгала, когда на звонок ответили и зелёная кнопка исчезла
.cp-actions {
    display: grid;
    grid-template-columns: repeat(2, 52px);
    gap: 10px;
    justify-items: center;
    align-items: center;

    &--single .reject-btn-wrap { grid-column: 1 / -1; }
}
// Узкий экран: клиент и кнопки в первой строке, обращение под ними на всю ширину
@media (max-width: 640px) {
    .call-panel--info {
        grid-template-columns: minmax(0, 1fr) auto;
    }
    .call-panel--info .cp-caller { grid-area: 1 / 1; padding-right: 0; border-right: 0; }
    .call-panel--info .cp-actions { grid-area: 1 / 2; }
    .call-panel--info .cp-info { grid-area: 2 / 1 / 3 / 3; }
}
// Постобработка после звонка дайлера — в той же панели, что и звонок (700 × 110), своя сетка без row/col
.acw-panel {
    min-height: $panel-min-height - 1px;
    display: flex;
    align-items: center;
    gap: 20px;
    padding: 0 20px 0 22px;
    color: #fff;
}
.acw-info {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 5px;
    line-height: 1.25;
}
.acw-head {
    display: flex;
    align-items: baseline;
    gap: 8px;
    font-size: 1.15rem;
    .acw-title { color: #ffc46b; font-weight: 700; }
    .acw-sub { color: #a9b3c1; font-size: .85rem; }
}
.acw-info .contact .link-contact { cursor: pointer; }
.acw-actions {
    flex: none;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 6px;
    min-width: 168px;
}
.acw-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 7px;
    height: 30px;
    padding: 0 14px;
    border-radius: 8px;
    border: 1px solid transparent;
    font: inherit;
    font-size: 13px;
    font-weight: 700;
    white-space: nowrap;
    cursor: pointer;
    outline: none;
    transition: background .15s, border-color .15s;
    &:disabled { opacity: .5; cursor: default; }
    &--primary { background: #47BAC1; color: #fff; &:hover { background: darken(#47BAC1, 6%); } }
    &--ghost { background: transparent; border-color: rgba(255, 255, 255, .4); color: #fff; &:hover { background: rgba(255, 255, 255, .08); } }
    &--link { height: 18px; padding: 0; background: transparent; color: #ffc46b; font-size: 12px; font-weight: 600; &:hover { text-decoration: underline; } }
}

// Второстепенные действия в панели звонка (под кнопками ответа/сброса): клавиатура и, на звонках дайлера, «Автоответчик»
.call-side-actions {
    grid-column: 1 / -1;
    display: flex;
    justify-content: center;
    gap: 8px;
}
.call-sq {
    position: relative;
    width: 40px;
    height: 40px;
    border: 0;
    border-radius: 10px;
    background: #2a3342;
    color: #fff;
    font-size: 15px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    outline: none;
    box-shadow: 0 1px 6px rgba(0, 0, 0, .25);
    transition: background .15s, transform .1s;
    &:hover { background: #3a4558; }
    &:active { transform: translateY(1px); }
    &.is-active { background: #47BAC1; }
    &:disabled { opacity: .5; cursor: default; }
    &--am {
        background: #c98a1b;
        &:hover { background: #d89a2a; }
    }
    &__tag {
        position: absolute;
        right: -6px;
        bottom: -6px;
        background: #fff;
        color: #7a5200;
        font-size: 9px;
        font-weight: 800;
        line-height: 1.2;
        padding: 1px 4px;
        border-radius: 6px;
        box-shadow: 0 1px 4px rgba(0, 0, 0, .3);
    }
}

.answer-btn-wrap, .reject-btn-wrap, .keyboard-btn-wrap {
    .btn-webphone-action {
        width: 52px;
        height: 52px;
        border-radius: 50%;
        box-shadow: 0 0.1rem 0.8rem rgba(0, 0, 0, 0.3);
        padding: 0.75rem;
        &.animate {
            transition:.3s;
            -webkit-animation:hoverWave linear 1s infinite;
            animation:hoverWave linear 1s infinite;
            i,svg {
                line-height: 66px;
                transition: .5s ease-in-out;
                animation: 1200ms ease 0s normal none 1 running shake;
                animation-iteration-count: infinite;
                -webkit-animation: 1200ms ease 0s normal none 1 running shake;
                -webkit-animation-iteration-count: infinite;
            }
        }
        i,svg {
            width: 100%;
            height: 100%;
        }
    }
}
.keyboard-btn-wrap button {
    background-color: #212833;
    color: white;

    &:hover {
        background-color: #404d62;
    }
    &:active {
        background-color: #4f5f79;
    }
}
</style>

<style lang="scss">
/* Размеры панели звонка (#block-call). По ним же встаёт окно выбора номера (CallDialog, placement="bottom-left"):
   в том же углу, той же ширины и над панелью, когда она показана.
   Высота здесь — обычной панели; у панели с обращением она больше, и пока панель показана,
   WebPhone.vue подставляет её настоящую высоту (trackPanelHeight) */
:root {
    --webphone-panel-width: 700px;
    --webphone-panel-height: 110px;
}
/* Подсказки софтфона рендерятся в body: поднимаем над панелью звонка (#block-call z-index 3000) */
.webphone-tooltip.el-tooltip__popper {
    z-index: 3100 !important;
}
</style>
